import * as React from 'react'
import Helmet from 'react-helmet'
import 'lazysizes'

import IbcNews from '../../components/IbcNews'
import Header from '../../components/Header'
import Footer from '../../components/core/Footer'
import FeatureToggle from '../../components/FeatureToggle'
import { IS_NEWS_ENABLED } from '../../constants/FeatureConstants'
import { PAGE_NOT_FOUND } from '../../constants/RouteConstants'
import darkTheme from '../../constants/themeConstants/darkTheme'

type Props = {} // eslint-disable-line
class News extends React.Component<Props> {
  render() {
    const {
      data,
      headerPropsData,
      footerProps,
      isBookNowSlotOpened,
      bookNowModalData
    } = this.props
    if (data) {
      const { mediaPageData } = data
      const {
        seoData,
        newsLogosList,
        newsDataList,
        readFullStoryText,
        watchVideoText,
        statsData
      } = mediaPageData.edges[0].node.frontmatter
      const {
        title,
        metaDescription,
        ogTitle,
        ogDescription,
        twitterTitle,
        twitterdescription
      } = seoData
      return (
        <FeatureToggle feature={IS_NEWS_ENABLED} redirectTo={PAGE_NOT_FOUND}>
          <Helmet>
            <title>{title}</title>
            <meta name="description" content={metaDescription} />
            <meta property="og:title" content={ogTitle} />
            <meta property="og:url" content="https://ib.cricket/media/" />
            <meta
              property="og:image"
              content="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/ibc-social-images/iBC-twitter-image.jpg"
            />
            <meta property="og:description" content={ogDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ib.cricket" />
            <meta property="twitter:title" content={twitterTitle} />
            <meta name="twitter:url" content="https://ib.cricket/media/" />
            <meta name="twitter:site" content="@playiBCricket" />
            <meta property="twitter:description" content={twitterdescription} />
            <meta
              name="twitter:image"
              content="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/ibc-social-images/iBC-twitter-image.jpg"
            />
          </Helmet>
          <section>
            <Header
              headerPropsData={headerPropsData}
              isBookNowSlotOpened={isBookNowSlotOpened}
              bookNowModalData={bookNowModalData}
            />
            <IbcNews
              newsDataList={newsDataList}
              newsLogosList={newsLogosList}
              readFullStoryText={readFullStoryText}
              watchVideoText={watchVideoText}
              statsData={statsData}
            />
          </section>

          <Footer {...footerProps} theme={darkTheme.footerSection} />
        </FeatureToggle>
      )
    }
    return null
  }
}

export default News
// eslint-disable-next-line
export const graphqlQuery = graphql`
  query mediaPageQuery {
    mediaPageData: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/media-page/" } }
    ) {
      edges {
        node {
          frontmatter {
            seoData {
              title
              metaDescription
              ogTitle
              ogDescription
              twitterTitle
              twitterdescription
            }
            newsLogosList {
              imageUrl
              height
              logoUrl
              mobileHeight
              altText
            }
            newsDataList {
              id
              imageUrl
              title
              date
              description
              newsUrl
              altText
              mobileImageurl
              isVideo
              leftColor
              rightColor
            }
            statsData {
              articlesCount
              articlesText
              mediaHousesCount
              mediaHousesText
            }
            readFullStoryText
            watchVideoText
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/media/index.js